import React, { Dispatch, SetStateAction } from 'react';
import { ScrollView, StyleSheet, View } from 'react-native';
import Option from '../../IssueList/components/IssueRow/components/Option';
import isMobile from '../../../../../IsMobile';
import SelectionModal from '../../../../../SelectionModal';
import Colors from '../../../../../../constants/Colors';
import { TemplateType, TemplateTypeTitles } from '../../../../../../constants/Types';

interface TemplateTypeListProps {
  templateTypeDropdownShown: boolean,
  setTemplateTypeDropdownShown: Dispatch<SetStateAction<boolean>>,
  selectedTemplateType: TemplateType,
  setSelectedTemplateType: Dispatch<SetStateAction<TemplateType>>,
}

const testIDs: string[] = [
  'asset-template-type-btn',
  'sensor-template-type-btn',
  'meter-template-type-btn',
];

const TemplateTypeList = ({
  templateTypeDropdownShown, setTemplateTypeDropdownShown, selectedTemplateType,
  setSelectedTemplateType,
}: TemplateTypeListProps) => {
  const List = () => <>
    {[TemplateType.ASSET, TemplateType.SENSOR, TemplateType.METER]
      .map((type: TemplateType, index: number) => <Option
        key={`template_group_dropdown_option_${type}`}
        text={TemplateTypeTitles[type]}
        onPress={() => {
          setSelectedTemplateType(type);
          setTemplateTypeDropdownShown(false);
        }}
        selected={type === selectedTemplateType}
        testID={testIDs[index]}
      />)}
  </>;

  return isMobile ? <SelectionModal
    listContent={<List />}
    title='Select template group'
    isVisible={templateTypeDropdownShown}
    hide={() => setTemplateTypeDropdownShown(false)}
  /> : <View style={{ zIndex: 2 }}>
    {templateTypeDropdownShown && <ScrollView
      nestedScrollEnabled
      style={styles.containerWeb}
    >
      <List />
    </ScrollView>}
  </View>;
};

const styles = StyleSheet.create({
  containerWeb: {
    maxHeight: 180,
    width: '100%',
    marginTop: 4,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: '#FFF',
    position: 'absolute',
    top: 1,
  },
});

export default TemplateTypeList;
